import { DocumentPath, EditorCommand } from '../types';
import { createId } from '../utils/createId';
import {
  cloneNode,
  findNode,
  insertNode,
  moveNode,
  removeNode,
} from '../utils/node';

export function createNodeCommand<Props>(
  type: string,
  path: DocumentPath,
  props?: Props,
): EditorCommand {
  return {
    exec({ setState, components }) {
      setState((state) => {
        // Create node inside it
        const child = components[type];
        return {
          ...state,
          cursor: path,
          document: insertNode(state.document, path, {
            key: createId(),
            type,
            props: {
              ...child.defaultProps
                ? typeof child.defaultProps === 'function'
                  ? child.defaultProps()
                  : child.defaultProps
                : {},
              ...props ?? {},
              children: null,
            },
            children:
              (child.defaultProps
                ? typeof child.defaultProps === 'function'
                  ? child.defaultProps()
                  : child.defaultProps
                : {}
              ).children ?? [],
          }),
        };
      });
    },
  };
}

export function cloneNodeCommand(path: DocumentPath): EditorCommand {
  return {
    exec({ setState }) {
      setState((state) => {
        const nextCursor = path.map((v, i) => (i === path.length - 1 ? v + 1 : v));
        const node = findNode(state.document, path);
        if (node == null) { return state; }
        return {
          ...state,
          cursor: nextCursor,
          document: insertNode(state.document, nextCursor, cloneNode(node)),
        };
      });
    },
  };
}

export function removeNodeCommand(path: DocumentPath): EditorCommand {
  return {
    exec({ setState }) {
      setState((state) => {
        const prevCursor = path.slice(0, -1);
        return {
          ...state,
          cursor: prevCursor,
          document: removeNode(state.document, path),
        };
      });
    },
  };
}

export function moveNodeCommand(
  srcPath: DocumentPath,
  destPath: DocumentPath,
): EditorCommand {
  return {
    exec({ setState }) {
      setState((state) => ({
        ...state,
        ...moveNode(state.document, srcPath, destPath),
      }));
    },
  };
}
